import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Icon extends PureComponent {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  render() {
    const { className, ...rest } = this.props;
    return (
      <i className={`${className || ''} icon-${this.props.icon}`} {...rest} />
    );
  }
}

export default Icon;
